import axios from "@/libs/api.request";
// 查询
export const getWhitelist = params => {
  return axios.request({
    url: "/user/whitelist",
    method: "GET",
    params
  });
};
// 详情
export const getWhitelistDetail = id => {
  return axios.request({
    url: `/user/whitelist/${id}`,
    method: "GET"
  });
};
// // 删除
// export const del = id => {
//   return axios.request({
//     url: `/user/whitelist/${id}`,
//     method: "DELETE"
//   });
// };
// 更新
export const updateWhitelist = data => {
  return axios.request({
    url: `/user/whitelist/${data.client_id}`,
    method: "PUT",
    data
  });
};
// // 新增
// export const add = data => {
//   return axios.request({
//     url: "/user/whitelist",
//     method: "POST",
//     data
//   });
// };
